module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-14-d6957eb9c3b7bfb018756920f58daf10.svg";